export const SEARCH_PARAM_LIMIT = 'limit'
export const SEARCH_PARAM_OFFSET = 'offset'

/** Length maximum of the data in the request. */
export const PAGINATION_LIMIT = 40

/** Extended length maximum of the data in the request. */
export const PAGINATION_LIMIT_EXTENDED = 200

export const api = {
    TICKET_PARAMETERS: 'ticket_parameters/',
    UPLOAD_SIGNATURE: 'images_sign_upload/',

    auth: {
        ASK_RESET_PASSWORD: 'auth/reset-password/ask/',
        CHECK_RESET_PASSWORD_TOKEN: 'auth/reset-password/check-token/',
        CONFIRM_RESET_PASSWORD: 'auth/reset-password/',
        LOGIN: 'token/',
        ME: 'me',
        REFRESH_TOKENS: 'token/refresh/',
    },

    catalogue: {
        priceTables: {
            DETAILS: 'price_table/:id/',
            LINES: 'price_table/:id/lines/',
            LIST: 'price_table/',
        },

        products: {
            DETAILS: 'products/:id/',
            LIST: 'products/',

            allergens: {
                DETAILS: 'allergens/:id/',
                LIST: 'allergens/',
                PRIORITIES: 'catalogue/products/allergens/priorities/',
            },

            categories: {
                DETAILS: 'categories_products/:id/',
                LIST: 'categories_products/',
                PRIORITIES: 'catalogue/products/categories/priorities/',
            },

            import: {
                CREATE: 'catalogue/products/import/create/',
                MODIFY: 'catalogue/products/import/modify/',
            },

            subcategories: {
                DETAILS: 'sub_categories_products/:id/',
                LIST: 'sub_categories_products/',
                PRIORITIES: 'catalogue/products/subcategories/priorities/',
            },
        },

        suppliers: {
            DETAILS: 'supplier_products/:id/',
            LIST: 'supplier_products/',
        },
    },

    machines: {
        ALL: 'machines/',

        lockers: {
            door: {
                OPEN: 'machines/lockers/:id/door/open/',
            },
        },

        relations: {
            DETAILS: 'next/machines_grid/:id/',
            LIST: 'next/machines_grid/',
        },

        distributors: {
            hatch: {
                UNLOCK: 'machines/distributors/:id/hatch/unlock/',
            },
        },

        microwaves: {
            DETAILS: 'machines/microwaves/:id',
            LIST: 'machines/microwaves',
        },

        planograms: {
            DETAILS: 'next/machines_grid_items/:id/',
            LIST: 'next/machines_grid_items/',
        },

        terminals: {
            SELF_SERVICE: 'machines/terminals/:id/self-service/',

            reboot: {
                APT: 'machines/terminals/:id/reboot/apt/',
            },

            restart: {
                COMPUTER: 'machines/terminals/:id/restart/computer/',
            },
        },
    },

    operations: {
        orders: {
            CANCEL: 'operations/orders/:id/cancel/',
            DETAILS: 'operations/orders/:id/',
            LIST: 'operations/orders/',
            PREPARATION: 'operations/orders/:id/preparation/',
        },
    },

    park: {
        DIAGNOSTIC: 'diagnostic/',

        clients: {
            DETAILS: 'site_customer/:id/',
            LIST: 'site_customer/',
        },

        managers: {
            DETAILS: 'clients/:id/',
            LIST: 'clients/',

            categories: {
                LIST: 'client_category/',
            },
        },

        sites: {
            DETAILS: 'sites/:id/',
            LIST: 'sites/',

            types: {
                DETAILS: 'site_types/:id/',
                LIST: 'site_types/',
                PRIORITIES: 'park/sites/types/priorities',
            },

            zones: {
                DETAILS: 'zones/:id/',
                LIST: 'zones/',
                PRIORITIES: 'park/sites/zones/priorities',
            },
        },
    },

    reports: {
        STOCK: 'reports/stock/',

        sale: {
            ALL: 'reports/sale/',
            DETAILS: 'reports/sale/:id',
        },

        service: {
            DETAILS: 'reports/service/:id/',
            LIST: 'reports/service/',
        },

        vat: {
            DETAILS: 'reports/vat/:id/',
            LIST: 'reports/vat/',
        },
    },

    settings: {
        THEME: 'colors_parameters/',

        email: {
            LIST: 'email_parameters/',
            DETAILS: 'email_parameters/:id/',
        },
    },

    transactions: {
        BLOCKED_CARDS: 'blocked_cards/',
        REFILLS: 'credit_refill/',

        sales: {
            CONTACT: 'transactions/sales/:id/contact',
            DETAILS: 'transactions/sales/:id/',
            LIST: 'transactions/sales/',
            RECEIPT: 'transactions/sales/:id/receipt/',
            REFUND: 'transactions/sales/:id/refund',
            REFUSE: 'transactions/sales/:id/refuse',
        },
    },

    users: {
        PERMISSIONS: 'users_permissions/',

        deliveryMen: {
            DETAILS: 'deliverymen/:id/',
            LIST: 'deliverymen/',
        },

        konsole: {
            DETAILS: 'users/:id/',
            IMPERSONATE: 'users/impersonate/',
            LIST: 'users/',
        },

        konvives: {
            CREATION_LINK: 'users/konvives/creation-link',
            DETAILS: 'machines_users/:id/',
            IMPORT: 'machines_users/import/',
            LIST: 'machines_users/',
        },

        profiles: {
            DETAILS: 'users_groups/:id/',
            LIST: 'users_groups/',
        },

        services: {
            DETAILS: 'users/services/:id/',
            LIST: 'users/services/',
        },

        technicians: {
            DETAILS: 'technicians/:id/',
            LIST: 'technicians/',
        },
    },
}
